<template>
  <div class="master-layout h-100">
    <header id="headerBaner" class="header bg-top" :class="[fixBanner, 'header-' + home]" :style="resovleHeaderStyle">
      <div class=" container">
        <!-- Logo + chuyên mục -->
        <div class="row align-items-center">
          <div class="w-110 logo_mobile pt-1 pb-1">
            <div class="logo align-middle">
              <b-link class="navbar-brand align-middle" to="/">
                <span class="brand-logo">
                  <VOVAT-logo-home :img-width="widthLogo" />
                </span>
              </b-link>
            </div>
          </div>
          <!-- Dấu ba gạch moblie -->
          <div class="w-110 category_mobile">
            <header-mobile :items="dataMenuAll" />
          </div>
          <div class="w-160 d-md-flex d-none mr-auto list_category">
            <div class="d-flex align-items-center" style="position: relative;">
              <ul v-if="dataMenu.length" class="nav">
                <li class="nav-item padding-custom-r-5 " style="color:#225d93">
                  <router-link class="nav-link  d-flex font-category" :class="currentSlug == '/' ? 'active' : ''"
                    :to="{ name: 'home' }">
                    <feather-icon icon="HomeIcon" width="22px" height="22px" />
                  </router-link>
                </li>
                <li v-for="(item, index) in dataMenu" :key="index"
                  class="nav-item padding-nav-item padding-custom-r-5 li_parent">
                  <router-link class="nav-link d-flex font-category a_category_parent" :title="item.title"
                    :class="currentSlug == item.slug ? 'active' : ''" :to="{ path: item.url }">
                    <span v-if="item.slug == '/'" class="icon_home" /> {{ item.title }} </router-link>
                  <ul class="nav_child">
                    <li v-for="(child, childKey) in item.childs" :key="childKey"
                      class="nav-item padding-nav-item padding-custom-r-5" style="">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" :title="child.title"
                        :class="currentSlug == child.slug ? 'active' : ''" :to="{ path: child.url }">
                        <span v-if="child.slug == '/'" class="icon_home " /> {{ child.title }}</router-link>
                    </li>
                  </ul>
                </li>
                <li v-if="$can('files.indexDalet', 'Files')"
                  class="nav-item padding-nav-item padding-custom-r-5 li_parent">
                  <router-link class="nav-link d-flex font-category a_category_parent" title="Multimedia"
                    :class="currentSlug == 'multimedia/dalet' ? 'active' : ''" :to="{ path: '/home/multimedia/dalet' }">
                    Multimedia </router-link>
                  <ul class="nav_child">
                    <li class="nav-item padding-nav-item padding-custom-r-5">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/home/multimedia/upload-dalet' }">Upload vào dalet</router-link>
                    </li>
                    <li class="nav-item padding-nav-item padding-custom-r-5">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/home/multimedia/dalet' }">Đến cổng điện tử</router-link>
                    </li>
                    <li class="nav-item padding-nav-item padding-custom-r-5">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/lich-phat-song' }">Lịch phát sóng</router-link>
                    </li>
                    <li class="nav-item padding-nav-item padding-custom-r-5 d-none">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/home/multimedia/editor-network' }">Đến mạng biên tập</router-link>
                    </li>
                    <li class="nav-item padding-nav-item padding-custom-r-5 d-none">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/home/multimedia/vov5' }">VOV5</router-link>
                    </li>
                    <li class="nav-item padding-nav-item padding-custom-r-5 d-none">
                      <router-link class="nav-link d-flex font-size14-be-vietnam font-weight-500" title="Dalet"
                        :to="{ path: '/home/multimedia/vovnews' }">VOVNEWS</router-link>
                    </li>
                  </ul>
                </li>
                <li v-if="$can('files.indexDalet', 'Files')"
                  class="nav-item padding-nav-item padding-custom-r-5 li_parent">
                  <router-link class="nav-link d-flex font-category a_category_parent" title="Multimedia"
                    :class="currentSlug == 'tin-moi' ? 'active' : ''" :to="{ path: '/home/tin-moi.html' }"> Tin mới
                  </router-link>
                </li>
              </ul>
              <div id="myDropdown" class="dropdown-content" style="">
                <div class="container">
                  <ul class="flex-wrap d-flex list-unstyled pl-1">
                    <li v-for="(item, index) in dataMenuAll" :key="index" class="w-20">
                      <router-link class="nav-link d-flex font-category font-weight-700" :to="{ path: item.url }">
                        <span class="font-size15-be-vietnam" style="">{{ item.title }}</span>
                      </router-link>
                      <ul class="nav" style="">
                        <li v-for="(child, childKey) in item.childs" :key="childKey"
                          class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366" style="">
                          <router-link class="nav-link d-flex font-category" style="" :title="child.title"
                            :class="currentSlug == child.slug ? 'active' : ''" :to="{ path: child.url }">
                            <span class="font-size14-be-vietnam">{{ child.title }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <button v-click-outside="outside" type="button" class="btn btn-icon btn_show_category" @click="inside">
                <feather-icon icon="MoreHorizontalIcon" class="" size="18" />
              </button>
            </div>
          </div>
          <div class="w-130 d-md-flex d-none p-0 justify-content-end list_item_action">
            <div class="d-flex justify-content-end font-category">
              <b-navbar-nav class="userinfo nav align-items-center">
                <notification-dropdown class="d-none d-sm-block notify-home" />
                <li class="p-0">
                  <router-link class="btn btn-sm btn_search_home " :to="{ name: 'search' }">
                    <feather-icon id="SearchIcon" icon="SearchIcon" class="SearchIcon p-0 " height="21px"
                      width="21px" /></router-link>
                </li>
                <li class="pl-1 pr-1 pading-right-li pading-left-li">
                  <router-link class="btn
                    btn-blue2
                    btn-create-article
                    justify-content-center" :to="{ name: 'dashboard' }"> Quản trị </router-link>
                </li>
                <li class="pr-1 pading-left-li">
                  <a href="/article/create" class="btn btn-blue2 btn-create-article justify-content-center">Viết bài</a>
                </li>
                <user-dropdown class="pl-1 pr-1 pading-right-li pading-left-li avatar-home " style="border-radius: 4px;">
                  <template #dropdownItemFirst="{ userData }">
                    <b-dropdown-header id="dropdown-header-label" class="text-center"> {{ userData ? userData.full_name :
                      '' }} </b-dropdown-header>
                    <b-dropdown-divider />
                    <b-dropdown-item :to="{ name: 'home-bookmark' }" link-class="d-flex align-items-center">
                      <feather-icon size="16" icon="BookmarkIcon" class="mr-50" />
                      <span>Tin đánh dấu</span>
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'dashboard' }" link-class="d-flex align-items-center">
                      <feather-icon size="16" icon="TabletIcon" class="mr-50" />
                      <span>{{ $t('Dashboard') }}</span>
                    </b-dropdown-item>
                  </template>
                </user-dropdown>
              </b-navbar-nav>
            </div>
          </div>
        </div>
        <div class="row" v-if="!this.$route.meta.is_head" :class="hideSlogan">
          <slogan-view />
        </div>
      </div>
    </header>
    <!-- <header
      v-else
      id="headerBanerCategory"
      class="header bg-top-category"
      :class="fixBanner"
      :style="{ 'min-height': 50 + 'px' }"
    >
      <header-category />
    </header> -->
    <div class="main" :class="'main-' + home">
      <div class="main-content">
        <slot />
      </div>
    </div>
    <footer class="footer">
      <slot name="footer">
        <footer-view />
      </slot>
    </footer>
    <slot name="customizer" />
  </div>
</template>

<script>

import {
  BLink, BNavbarNav, BDropdownItem, BDropdownHeader, BDropdownDivider, VBTooltip,
} from 'bootstrap-vue'
import {
  ref, computed, onMounted, watchEffect, onBeforeUnmount,
} from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import useAppConfig from '@core/app-config/useAppConfig'
import store from '@/store'
import { $themeConfig } from '@themeConfig'
import VOVATLogoHome from '@core/layouts/components/LogoHome.vue'
import NotificationDropdown from '@core/layouts/components/app-navbar/components/NotificationHomeDropdown.vue';
import UserDropdown from '@core/layouts/components/app-navbar/components/UserHomeDropdown.vue';
import { useRouter } from '@/@core/utils/utils';
import SloganView from '../partials/SloganView.vue'
import FooterView from '../partials/FooterView.vue'
import HeaderMobile from '../partials/HeaderMobile.vue'

export default {
  components: {
    SloganView,
    FooterView,
    VOVATLogoHome,
    NotificationDropdown,
    UserDropdown,
    BLink,
    BNavbarNav,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
    HeaderMobile,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,

    'click-outside': {
      bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const { bubble } = binding.modifiers
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      },
    },
  },
  data() {
    return {
      scrollPosition: null,
    };
  },
  computed: {
    // Imgsize() {
    //   return this.$store.state.home.bannerMinHeight
    // },
  },

  methods: {
    showSubMenu() {
      document.getElementById('myDropdown').classList.toggle('show');
    },
    renderNoty(data) {
      return data.join(' - ')
    },
    outside(e) {
      this.clickOutside += 1
      const container = document.getElementById('myDropdown');
      if (container.classList.contains('show')) {
        document.getElementById('myDropdown').classList.remove('show');
      }
    },
    inside(e) {
      this.clickInside += 1
      document.getElementById('myDropdown').classList.toggle('show');
    },

    changeClassHeader() {
      this.hideSlogan = '';
      this.Imgsize = 240;
      this.fixBanner = ''
    },
  },
  setup() {
    const { route, router } = useRouter();
    const {
      routerTransition, navbarBackgroundColor, isNavMenuHidden,
    } = useAppConfig()
    const { appName, appLogoImage } = $themeConfig.app
    const currentSlug = ref('/');
    const dataMenu = ref([])
    const dataMenuAll = ref([])
    const dataNoty = ref([])
    const dataCountNews = ref([])
    const hideSlogan = ref('')
    const fixBanner = ref('')
    const headRef = ref(null); // obtain the reference
    const home = ref('home'); // obtain the reference
    const Imgsize = computed({
      get() {
        return store.state.home.bannerMinHeight
      },
      set(val) {
        store.dispatch('home/setHeight', val)
      },
    });
    const widthLogo = computed({
      get() {
        return store.state.home.widthLogo
      },
      set(val) {
        store.dispatch('home/setWidthLogo', val)
      },
    });
    const classShowCountNews = computed({
      get() {
        return store.state.home.classShowCountNews
      },
      set(val) {
        store.dispatch('home/setClassShowCountNews', val)
      },
    });
    watchEffect(
      () => {
        currentSlug.value = route.value.params.slug
          ? route.value.params.slug
          : '/';

        if (route.value.name === 'home') {
          Imgsize.value = 50;
          widthLogo.value = 100;
          hideSlogan.value = ''
          fixBanner.value = ''
          home.value = 'home'
          classShowCountNews.value = 'hideCountNewsRight'
        } else {
          Imgsize.value = 50
          widthLogo.value = 100;
          hideSlogan.value = 'hideSlogan';
          fixBanner.value = ''
          home.value = 'category'
          classShowCountNews.value = 'showCountNewsRight'
        }
      },

    );
    store.dispatch('home/config').then(response => {
      const result = response.data;
      if (result.code === 200) {
        dataMenu.value = result.data.menu
        // console.log('data Menu', dataMenu.value)
        dataMenuAll.value = result.data.menu_all
        // console.log('dataMenuAll', dataMenuAll.value);
      }
    })
    store.dispatch('home/notification').then(response => {
      const result = response.data;
      if (result.code === 200) {
        // console.log('result_notif', result.data);
        dataNoty.value = result.data
      }
    })

    const scrollChange = () => {
      const curr = window.pageYOffset;
      if (window.scrollY <= 20) {
        if (currentSlug.value === '/') {
          hideSlogan.value = '';
          // Imgsize.value = 240;
          // widthLogo.value = 120;
          fixBanner.value = ''
          classShowCountNews.value = 'hideCountNewsRight'
        } else {
          hideSlogan.value = 'hideSlogan';
          // Imgsize.value = 50
          // widthLogo.value = 90;
          fixBanner.value = 'fixBanner'
          classShowCountNews.value = 'showCountNewsRight'
        }
        // console.log('curr-0', curr)
      } else if (window.scrollY > 20 || currentSlug.value !== '/') {
        hideSlogan.value = 'hideSlogan';
        // Imgsize.value = 50
        // widthLogo.value = 90;
        fixBanner.value = 'fixBanner'
        classShowCountNews.value = 'showCountNewsRight'
      }
    }

    const resovleHeaderStyle = () => {
      let styles = { 'min-height': `${Imgsize.value}px` }
      if (home.value === 'category') {
        styles = { 'min-height': '50px' }
      }
      return styles;
    }

    onMounted(() => {
      window.addEventListener('scroll', scrollChange);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', scrollChange);
    });

    return {
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden,
      dataMenu,
      dataMenuAll,
      dataNoty,
      appName,
      appLogoImage,
      currentSlug,
      Imgsize,
      widthLogo,
      dataCountNews,
      hideSlogan,
      fixBanner,
      home,
      classShowCountNews,
      resovleHeaderStyle,
    }
  },

}
</script>
<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";
@import url('https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&family=Inter:wght@400;500;600;700&family=Manrope:wght@200;300;400;500;600;700;800&family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
// @import url('@/assets/scss/home.css');
// @import url('@/assets/scss/home.scss');
// @import url('@/assets/scss/categoryContent.scss');
// @import url('@/assets/scss/category.scss');
</style>
